import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { toastService } from '../../../../components/Toast/toast.service';
import { useAuth } from '../../AuthContext';
import { CompleteSignUpFormValues } from '../../auth.model';

export function useOnSubmit(onSuccess: () => void): (values: CompleteSignUpFormValues) => Promise<any> {
  const { signUp, updateInformation } = useAuth();
  const { t } = useTranslation();

  return useCallback(
    (values) => {
      return signUp(values).then(async () => {
        updateInformation(values.firstName + ' ' + values.lastName);
        toastService.show(t('AUTH.SIGN_UP.API_RESPONSE_SUCCESS'), t('SUCCESS'));
        await new Promise((resolve) => setTimeout(resolve, 1000));
        onSuccess?.();
      });
    },
    [signUp, updateInformation, onSuccess, t]
  );
}
